// ElevenLabs expressive voices put voice directions like "[smile]" into the agent's text.
// Strip them from AGENT messages only — never candidate text, code or "[SYSTEM]" (uppercase).
// Same rule as backend app/services/phase3_transcript.py.
const EXPRESSION_TAG = /(^|\s)\[[a-z][a-z '-]{1,29}\](?=\s|$|[.,!?;:])/g;

export function stripExpressionTags(text) {
  if (!text || text.indexOf('[') === -1) return text;
  return text
    .replace(EXPRESSION_TAG, '$1')
    .replace(/[ \t]{2,}/g, ' ')
    .replace(/ +([.,!?;:])/g, '$1')
    .trim();
}

export function isAgentSource(source) {
  return ['ai', 'agent', 'assistant'].includes(String(source || '').toLowerCase());
}
